document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-rivet-cart-addon]');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;
  const card = button.closest('.rivet-cart-addon');
  const error = card?.querySelector('.rivet-cart-addon__error');
  const label = button.querySelector('span');
  const originalLabel = label?.textContent || '';
  const id = Number(button.dataset.variant);
  const quantity = Number(button.dataset.quantity);
  const parentKey = button.dataset.parentKey;
  if (!id || !Number.isInteger(quantity) || quantity < 1 || !parentKey) return;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (label) label.textContent = button.dataset.busyText || originalLabel;
  if (error instanceof HTMLElement) error.hidden = true;
  try {
    const response = await fetch(button.dataset.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity, parent_line_key: parentKey }] }),
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error('Add-on could not be added');
    window.location.reload();
  } catch {
    if (error instanceof HTMLElement) error.hidden = false;
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (label) label.textContent = originalLabel;
  }
});
